module.exports = {
  name: 'default',
  waitForImages: false,
  transitionHeight: null,
  settings: {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    variableWidth: false,
    adaptiveHeight: false,
  //  mobileFirst: true,
    centerMode: false,
    centerPadding: '',
    autoplay: false,
    autoplaySpeed: 2000,
    // responsive: [
    //   { breakpoint: 'md',
    //     settings: {
    //       infinite: false,
    //       slidesToShow: 1,
    //       slidesToScroll: 1
    //     }
    //   }
    // ]
  },
}
